var React = require('react');

function RemoveDocumentIconInline (overrides) {
const props = Object.assign({}, {"viewBox":"0 0 64 64","fill":"none"}, overrides);
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32.5","r":"32","fill":"#ffede8","key":0}),React.createElement("path",{"d":"M26 22c-1.1 0-1.99.9-1.99 2L24 40c0 1.1.89 2 1.99 2H38c1.1 0 2-.9 2-2V28l-6-6h-8zm7 7v-5.5l5.5 5.5H33z","fill":"#c13e06","key":1})]);
}

module.exports = RemoveDocumentIconInline;

RemoveDocumentIconInline.default = RemoveDocumentIconInline;
